import React from 'react'
import { Badge } from '@/components/ui/badge'
import { Checkbox } from '@/components/ui/checkbox'
import TaskAssignee from '../tasks/assignee'
import TaskDue from '../tasks/due'

class TasksRow extends React.Component {

  onToggle = () => {
    this.props.onToggle(this.props.task)
  }

  onOpen = (e) => {
    e.preventDefault()
    this.props.onOpen(this.props.task)
  }

  onOwnerChange = (assignee) => {
    if (this.props.onOwnerChange) {
      this.props.onOwnerChange(this.props.task, assignee)
    }
  }

  onDueChange = (due_at) => {
    if (this.props.onDueChange) {
      this.props.onDueChange(this.props.task, due_at)
    }
  }

  render() {
    const task = this.props.task
    const completed = task.workflow_state === 'complete'
    const owner = task.owner

    const overdue = !completed && task.due_at && new Date(task.due_at) < new Date()

    return (
      <div className={
        'flex flex-wrap items-center py-3 md:flex-nowrap ' +
        (completed ? 'text-muted-foreground' : 'text-foreground')
      }>
        <div className="w-8 shrink-0">
          <Checkbox
            checked={completed}
            disabled={!(task.actions && task.actions.can_edit)}
            onCheckedChange={this.onToggle}
          />
        </div>

        <div className="min-w-0 flex-1 pr-3">
          <a
            href="#"
            onClick={this.onOpen}
            className={
              'block truncate ' +
              (completed ? 'text-muted-foreground line-through' : 'font-medium hover:underline')
            }
            title={task.name}
          >
            {task.name}
          </a>
          {task.priority ? (
            <Badge variant="destructive" className="mt-1">
              Priority {task.priority}
            </Badge>
          ) : null}
        </div>

        <div className="w-44 shrink-0 truncate text-sm" title={task.person && task.person.name}>
          {task.person && task.person.name ? task.person.name : <span className="text-muted-foreground/50">—</span>}
        </div>

        <div className="w-32 shrink-0 text-sm">
          <TaskAssignee
            assignee={owner}
            team={task.team}
            assignees={this.props.assignees || []}
            onChange={this.onOwnerChange}
          />
        </div>

        <div className={
          'w-32 shrink-0 text-sm ' +
          (overdue ? 'font-medium text-destructive' : 'text-muted-foreground')
        }>
          <TaskDue
            key={task.due_at}
            due_at={task.due_at}
            onChange={this.onDueChange}
          />
        </div>
      </div>
    )
  }
}

export default TasksRow
